import {useAppSelector} from "@/store";
import {StudentState} from "@/store/slices/student";

export const useStudentStore = (): StudentState => {
    return useAppSelector(state => state.student)
}
